import { PURGE } from 'redux-persist';
import {
  LOGIN,
  LOGOUT,
  SAVE_STUDENT,
} from '../actionTypes';

export function saveCredentials(domain, token, currentEmployeeId) {
  return {
    type: LOGIN,
    payload: { domain, token, currentEmployeeId },
  };
}

export function reduxPersistPurgeAction(key = 'root') {
  return {
    type: PURGE,
    key,
    result: () => null,
    payload: {},
  };
}

export function logout() {
  return {
    type: LOGOUT,
  };
}

export function saveStudentAction(isStudent) {
  return {
    type: SAVE_STUDENT,
    payload: { isStudent },
  };
}
